import React from 'react';
import { motion } from 'framer-motion';
import { Star, Quote } from 'lucide-react';
const testimonials = [{
  quote: 'Lo compré el domingo y el lunes tenía la semana resuelta. Las actividades del Tomo 3 las apliqué tal cual con mis alumnos y les encantó. No improvisé más.',
  name: 'Carolina M.',
  role: 'Profesora de Plástica · Primaria',
  city: 'Córdoba',
  initial: 'CM',
  color: 'bg-brand-500'
}, {
  quote: 'Doy clases hace 12 años y nunca tuve un material tan completo. Las rúbricas me salvaron el año entero. Llego al aula y sé exactamente qué evaluar.',
  name: 'Marcelo L.',
  role: 'Profesor de Arte · Secundaria',
  city: 'Buenos Aires',
  initial: 'ML',
  color: 'bg-terra-500'
}, {
  quote: 'Pensé que era otro PDF más. Me equivoqué. Es un sistema. Tengo Primaria y Secundaria cubiertos. Dejé de armar clases a las 11 de la noche.',
  name: 'Luciana R.',
  role: 'Profesora de Educación Artística · Primaria y Secundaria',
  city: 'Mendoza',
  initial: 'LR',
  color: 'bg-brand-600'
}, {
  quote: 'El bono de efemérides solo ya justifica la compra. Las actividades están pensadas, no son relleno. Eso lo noté enseguida. Muy buen nivel pedagógico.',
  name: 'Sofía D.',
  role: 'Profesora de Plástica · Primaria',
  city: 'Rosario',
  initial: 'SD',
  color: 'bg-terra-600'
}, {
  quote: 'Me lo recomendó una colega del departamento. Lo descargué el viernes a la noche y el sábado ya tenía el mes planificado. El de Historia del Arte es una joya.',
  name: 'Alejandra T.',
  role: 'Profesora de Arte · Secundaria',
  city: 'La Plata',
  initial: 'AT',
  color: 'bg-brand-700'
}];
export function Testimonials() {
  return <section className="py-24 lg:py-32 bg-paper-main" data-id="element-259">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-260">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="text-center mb-16 max-w-3xl mx-auto" data-id="element-261">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-terra-50 text-terra-600 font-medium text-xs uppercase tracking-widest mb-6 border border-terra-100" data-id="element-262">
            VOCES REALES
          </div>
          <h2 className="text-3xl md:text-5xl font-serif font-medium text-ink-800 mb-6 leading-tight tracking-tight" data-id="element-263">
            Lo que dicen <span className="text-brand-500" data-id="element-264">los profesores</span>
          </h2>
          <p className="text-lg text-ink-600 font-normal" data-id="element-265">
            Docentes de Arte de toda Argentina
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8" data-id="element-266">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.08,
          duration: 0.8,
          ease: 'easeOut'
        }} className={`bg-paper-card rounded-[20px] p-8 shadow-soft border border-paper-border transition-shadow hover:shadow-card relative flex flex-col ${i === 3 ? 'lg:col-start-1' : ''} ${i === 4 ? 'lg:col-start-2' : ''}`} data-id="element-267">
              <Quote className="absolute top-6 right-6 w-8 h-8 text-paper-alt" fill="currentColor" data-id="element-268" />
              <div className="flex text-accent-400 mb-6" data-id="element-269">
                {[...Array(5)].map((_, j) => <Star key={j} className="w-4 h-4 fill-current" data-id="element-270" />)}
              </div>
              <p className="text-ink-800 leading-relaxed mb-8 text-[15px] font-normal flex-1" data-id="element-271">
                "{t.quote}"
              </p>
              <div className="flex items-center gap-4 pt-6 border-t border-paper-border mt-auto" data-id="element-272">
                <div className={`${t.color} w-12 h-12 rounded-full flex items-center justify-center text-white font-medium text-sm shadow-sm`} data-id="element-273">
                  {t.initial}
                </div>
                <div data-id="element-274">
                  <div className="font-medium text-ink-800 text-sm" data-id="element-275">
                    {t.name}
                  </div>
                  <div className="text-ink-600 text-xs font-normal mt-0.5" data-id="element-276">
                    {t.role} · 📍 {t.city}
                  </div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}